import React from 'react';
import { selectStyle } from '../../tokens';
import Field from '../Field';

const ASSIGN_OPTIONS = [
  { value: 'Auto', label: 'Auto (load balanced)' },
  { value: 'Round robin', label: 'Round robin' },
  { value: 'Manual', label: 'Manual' },
];

export default function AssignNodeEditor({ assignAgent, onAssignAgentChange }) {
  return (
    <Field label="Assignment method">
      <select
        style={selectStyle}
        value={assignAgent || 'Auto'}
        onChange={(e) => onAssignAgentChange(e.target.value)}
      >
        {ASSIGN_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
    </Field>
  );
}
